import React from 'react'
import { View, Text, useDripsyTheme } from 'dripsy'
import { useAnimatedHover } from '@beatgig/hooks'
import Ionicons from '@expo/vector-icons/Ionicons'
import { TouchableOpacity } from 'react-native'
import { SxStyleProp } from 'theme-ui'

type Props = {
  children: React.ReactNode
  icon?: boolean
  color?: boolean | string
  underline?: boolean
  block?: boolean
  onPress?: () => void
  textSx?: SxStyleProp
} & React.ComponentProps<typeof View>

export default function Link(props: Props) {
  const {
    sx = {},
    children,
    color = false,
    icon,
    textSx = {},
    block,
    onPress,
  } = props

  const { colors, space } = useDripsyTheme().theme
  let mainColor: string
  if (typeof color === 'boolean') {
    mainColor = color ? 'primary' : 'text'
  } else {
    mainColor = color
  }
  const iconColor = colors?.[mainColor]

  const { isHovered, ref, resetStyle } = useAnimatedHover({
    webStyleKeys: ['background-color', 'color', 'text-decoration'],
  })
  let blockStyle = {}
  if (block) {
    blockStyle = {
      px: 2,
      py: 2,
      borderRadius: 2,
      bg: isHovered ? `${colors?.[mainColor]}30` : 'transparent',
    }
  }

  return (
    <TouchableOpacity onPress={onPress} disabled={!onPress}>
      <View
        ref={ref}
        sx={{
          alignItems: 'center',
          flexDirection: 'row',
          ...blockStyle,
          ...resetStyle,
          ...sx,
        }}
      >
        <Text sx={{ color: mainColor, fontSize: 3, ...textSx }}>
          {children}
        </Text>
        {!!icon && (
          <Ionicons
            name="md-open"
            size={20}
            color={iconColor}
            style={{ marginLeft: space?.[1] }}
          />
        )}
      </View>
    </TouchableOpacity>
  )
}
